import React from "react";
import { PhoneCallIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Footer() {
  let href = /Mobi|Mobile|Tablet/i.test(navigator.userAgent)
    ? "tel:02155439270"
    : "/contact_us";

  return (
    <div className="grid w-full grid-flow-row space-y-5 text-green-50 bg-green-700 p-5 text-xs shadow-[rgba(0,0,15,0.2)_0px_-1px_5px_1px] md:h-72 md:grid-cols-5 md:space-y-0 md:py-16 md:text-sm">
      <Link
        to={"./"}
        title="صفحه اصلی"
        onClick={() => window.scrollTo(0, 0)}
        className="flex flex-col items-center space-y-2 self-start font-traffic"
      >
        <img
          src="/imgs/logo.svg"
          className="h-14 brightness-125  md:h-32 "
          loading="lazy"
          alt="لوگوی آزمایاران"
        />
        <p className="text-white">یار مطمئن آزمایشگاهیان</p>
      </Link>
      <div>
        <ul className="space-y-2 text-white">
          <li>
            <a
              href="https://blog.azmayaran.com/"
              target="_blank"
              title="وبلاگ آزمایاران"
              className="p-2 hover:text-green-950 transition ease-in-out"
            >
              وبلاگ
            </a>
          </li>

          <li>
            <Link
              to={"/products/all"}
              title="محصولات آزمایاران"
              className="p-2 hover:text-green-950 transition ease-in-out"
            >
              محصولات
            </Link>
          </li>
          {/* <li>
            <HashLink
              to={"./#services"}
              title="مشاهده خدمات ما"
              className="p-2 hover:text-gray-800"
            >
              خدمات
            </HashLink>
          </li> */}
          {/* <li>
            <Link
              to={"./"}
              title="تعرفه استفاده از نرم‌افزار آزمایاران"
              className="p-2 hover:text-gray-800"
              onClick={() => window.scrollTo(0, 0)}
            >
              تعرفه
            </Link>
          </li> */}
        </ul>
        <div className=" hover:cursor-pointer">
          {/* . */}
          <a
            referrerPolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=602082&Code=jOvcUGn9ORV4voYfVJlddOz0Li7JTvrN"
          >
            <img
              referrerPolicy="origin"
              src="https://trustseal.enamad.ir/logo.aspx?id=602082&Code=jOvcUGn9ORV4voYfVJlddOz0Li7JTvrN"
              alt="eNamad"
              code="jOvcUGn9ORV4voYfVJlddOz0Li7JTvrN"
            />
          </a>
        </div>
      </div>

      <div>
        <ul className="space-y-2 text-white">
          <li>
            <Link
              to={"./about_us"}
              title="درباره آزمایاران"
              className="p-2 hover:text-gray-800"
              onClick={() => window.scrollTo(0, 0)}
            >
              درباره ما
            </Link>
          </li>
          <li>
            <Link
              to={"./contact_us"}
              title="تماس با آزمایاران"
              className="p-2 hover:text-gray-800"
              onClick={() => window.scrollTo(0, 0)}
            >
              تماس با ما
            </Link>
          </li>
          <li>
            <Link
              to={"./QA"}
              title="سوالات متداول"
              className="p-2 hover:text-gray-800"
              onClick={() => window.scrollTo(0, 0)}
            >
              سوالات متداول
            </Link>
          </li>
        </ul>
      </div>
      <div className="font-semibold text-gray-900 md:col-span-2 md:ml-32">
        <a
          className="flex items-center justify-center rounded-lg shadow text-green-900 bg-linear-to-l from-green-100 to-green-50 p-2 transition duration-300 ease-in-out hover:brightness-75"
          href={href}
          title="تماس با پشتیبانی نرم‌افزار"
        >
          <PhoneCallIcon weight="fill" size={24} className="ml-2" />
          همین حالا با ما تماس بگیرید!
        </a>
      </div>
    </div>
  );
}
